import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Stack from "@mui/material/Stack";
import { useRef } from "react";
import {
  scrollContainerSx,
  stickyContainerSx,
  sectionContainerSx,
  flywheelContainerSx,
} from "./OntologyFlywheelAdvantageSection.sx";
import { FlywheelSvg } from "./FlywheelSvg";
import {
  sectionTitle,
  sectionDescription,
} from "./OntologyFlywheelAdvantageSection.config";
import { useFlywheelAnimation } from "./useFlywheelAnimation";

export const OntologyFlywheelAdvantageSection = () => {
  const svgRef = useRef<SVGSVGElement>(null);
  const sectionRef = useRef<HTMLElement>(null);

  useFlywheelAnimation(svgRef, sectionRef);

  return (
    <Box
      component="section"
      id="ontology-flywheel-advantage"
      sx={scrollContainerSx}
      ref={sectionRef}
    >
      <Box sx={stickyContainerSx}>
        <Box sx={sectionContainerSx}>
          <Stack
            direction={{ xs: "column", md: "row", "2xl": "column" }}
            gap={{ xs: "2rem", md: "5rem", "2xl": "2rem" }}
            justifyContent="space-between"
            width="100%"
          >
            <Typography variant="h2" component="h2">
              {sectionTitle}
            </Typography>
            <Typography
              variant="body1"
              component="p"
              maxWidth={{ xs: "100%", md: "400px", lg: "500px", "2xl": "100%" }}
            >
              {sectionDescription}
            </Typography>
          </Stack>

          <Box sx={flywheelContainerSx}>
            <FlywheelSvg ref={svgRef} />
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default OntologyFlywheelAdvantageSection;
